import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function Instruction() {
  return (
    <p className={style.instruction}>
      A heat block can be set to a particular temperature to incubate samples at
      a constant temperature over a period of time. It has 8 slots into which
      1.5 ml or 0.2 ml tubes can be inserted. Set the heat block to the desired
      temperature using the display on the left. It can take a moment for the
      heat block to warm up, so its actual temperature is shown on the right
      display.
    </p>
  );
}

Instruction.propTypes = {};
